<template>

  <div v-if="isLoading" >
      <div class="lds-ring"><div /><div /><div /><div /></div>
  </div>

    <div v-else class="form-container">
        <h2>Add Funds by Credit Card</h2>

      <div class="form-row mt-2">
        <label class="label required">Amount ($)</label>
        <div class="value">
          <input
            v-model="amount"
            class="select"
            type="number"
            min="0"
          >
        </div>
      </div>
      <div class="form-row mt-3 form-footer">
        <button class="button button-sm rounded" :disabled="amount <= 0" @click="apply()">Pay Now</button>
      </div>
    </div>

</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

import { useToast } from 'vue-toast-notification';

const $toast = useToast();
export default {
  name: 'TopupFunds',
  components: {
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      amount: 0,
      isLoading:false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isAdmin() {
      return this.user && (this.user.role === 'admin');
    },
    isSuper() {
      return this.user && (this.user.role === 'super');
    },
  },
  async created() {
    if (!this.isAdmin && !this.isSuper) {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    async apply() {
      this.isLoading=true;
      const dsConn = new DatastoreConnect();
      const success_url = `${window.location.origin}/admin/transactions`;
      const fail_url = `${window.location.origin}/admin/payment_fail`;
      const ret = await dsConn.topupFunds({
        amount: this.amount, success: success_url, fail: fail_url,
      });

      if (ret.result) {
        const url = ret.result["url"];
        if (url.includes("admin/transactions")) {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Successfully added USD ${this.amount.toFixed(2)} to your funds.`,
            type: "success",
            position: "top",
          });
          this.amount = 0;
        } else if (url.includes("admin/payment_fail")) {
          $toast.open({
            queue: true,
            dismissible: true,
            message: `Top-up failed.`,
            type: "error",
            position: "top",
          });
          this.amount = 0;
        } else {
          this.isLoading=false;
          window.open(url,'_blank');
        }
      } else {
         let msg=`Error Adding Funds`;
        if (ret.error) {
          msg=ret.error.message
        }

         $toast.open({
            queue: true,
            dismissible: true,
            message: msg,
            type: "error",
            position: "top",
         });


      }
       this.isLoading=false;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
